import { Discount, DiscountType } from "../../domain";
import {
  DiscountRemoteDataSourceError,
  Endpoints,
  RemoteDataSource,
} from "../core";

export class DiscountRemoteDataSource extends RemoteDataSource {
  public async add(
    type: DiscountType,
    amount: number,
    code: string,
    expiration: Date,
    phoneNumber?: string
  ): Promise<void> {
    try {
      await this.post(Endpoints.addDiscount, {
        body: {
          phone_number: phoneNumber === undefined ? "" : phoneNumber,
          usage: type,
          amount: amount,
          code: code,
          expiration: expiration.toISOString(),
        },
      });
    } catch (error) {
      if (!error.response) throw DiscountRemoteDataSourceError.networkError();
      throw DiscountRemoteDataSourceError.serverError();
    }
  }

  public async remove(id: string): Promise<void> {
    try {
      await this.post(Endpoints.removeDiscount, { body: { id } });
    } catch (error) {
      if (!error.response) throw DiscountRemoteDataSourceError.networkError();
      throw DiscountRemoteDataSourceError.serverError();
    }
  }

  public async list(): Promise<Discount[]> {
    try {
      const res = await this.get(Endpoints.listDiscounts);
      return res.data.map((json: any) => new Discount().deserialize(json));
    } catch (error) {
      if (!error.response) throw DiscountRemoteDataSourceError.networkError();
      throw DiscountRemoteDataSourceError.serverError();
    }
  }
}
